import { useState } from 'react';

// Custom hook to manage button disable state
const useDisableButton = () => {
  const [isDisabledAfterSubmit, setIsDisabledAfterSubmit] = useState(false);

  const disableButton = () => {
    setIsDisabledAfterSubmit(true);
  };

  return { isDisabledAfterSubmit, disableButton };
};

export default useDisableButton;
